import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect';
import { HotlineClientReorderConfirmPage } from '@/feature/hotline/client/detail/reorder/confirm/page/HotlineClientReorderConfirmPage';
import { useHotlineClientReorderFormContext } from '@/feature/hotline/client/detail/reorder/context/HotlineClientReorderFormContext';
import { useParams } from '@/hooks/lib/react-router/useParams';
import { pagePath } from '@/utils/router/pagePath';
/**
 * 匿名ホットラインもう一度相談する 確認
 */
export const HotlineClientReorderConfirm = () => {
    const { id = '', requestId = '' } = useParams();
    const { formValues } = useHotlineClientReorderFormContext();
    // formValues がない場合は入力画面にリダイレクト
    if (!formValues) {
        return (_jsx(CustomRedirect, { to: pagePath.hotline.client.reorderInput(id, requestId) }));
    }
    return (_jsx(HotlineClientReorderConfirmPage, { formValues: formValues, id: id, requestId: requestId }));
};
